<template>
  <PageContent type="center" :compClass="'flex flex-col space-y-6'">
    <div class="flex flex-row items-center justify-between">
      <h1 class="text-xl font-semibold">Credit Management</h1>
      <button
        class="px-3 py-1.5 bg-blue-700 rounded-lg text-white focus:outline-none"
        v-on:click="networkCreditToggleModal"
      >
        Add a Credit Plan
      </button>
    </div>

    <div>
      <h1 class="font-medium mb-2 tracking-wide text-gray-600">
        Current Usage (last updated
        {{ creditUsage.valid | displayLocalDateTime }})
      </h1>
      <div class="space-y-2">
        <div
          class="bg-white flex flex-col divide-y divide-gray-200 rounded-md overflow-hidden"
        >
          <div v-for="usage in creditUsage.data" v-bind:key="usage.name">
            <div class="flex flex-row justify-between p-3">
              <span class="whitespace-nowrap overflow-ellipsis overflow-hidden">
                {{ usage.name }}
              </span>
              <div>
                {{ usage.usage }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="">
      <h1 class="font-medium mb-2 tracking-wide text-gray-600">
        Credit Agreements
      </h1>
      <CustomTable class="rounded-md overflow-hidden shadow-md mb-4">
        <template v-slot:header>
          <th
            class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
          >
            Network
          </th>
          <th
            class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
          >
            Invoice Reference
          </th>
          <th
            class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
          >
            Credit Amount
          </th>
          <th
            class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
          >
            Total Price
          </th>
          
          <th
            class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
          >
            Created
          </th>
          <th
            class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
          >
            Expires
          </th>
          <th
            class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
          >
          </th>
        </template>
        <template v-slot:body>
          <tr
            class="hover:bg-grey-lighter"
            v-for="agreement in creditAgreements"
            v-bind:key="agreement.id"
          >
            <td class="py-4 px-6 border-b border-grey-light">
              {{ agreement.network.name }}
            </td>
            <td class="py-4 px-6 border-b border-grey-light">
              {{ agreement.invoice_number }}
            </td>
            <td class="py-4 px-6 border-b border-grey-light">
              {{ agreement.credits }}
            </td>
            <td class="py-4 px-6 border-b border-grey-light">
              ${{ agreement.price }}
            </td>
            <td class="py-4 px-6 border-b border-grey-light">
              {{ agreement.created_at }}
            </td>
            <td class="py-4 px-6 border-b border-grey-light">
              {{ agreement.expires_at }}
            </td>
            <td class="py-4 px-6 border-b border-grey-light">
              <router-link :to="{name: 'AdminCreditAgreementInfo', params: { id: agreement.id } }">View</router-link>
            </td>
          </tr>
          <tr class="hover:bg-grey-lighter" v-if="creditAgreements.length == 0">
            <td
              colspan="6"
              class="py-4 px-6 border-b border-grey-light text-center"
            >
              No agreements found.
            </td>
          </tr>
        </template>
      </CustomTable>
    </div>
    <NetworkAddCreditModal />
  </PageContent>
</template>

<script>
import * as Config from "@/config";
import PageContent from "@/components/PageContent";
import NetworkAddCreditModal from "@/screens/admin/modals/NetworkAddCreditModal";
import CustomTable from "@/components/general/CustomTable";

export default {
  name: "AdminHome",
  data() {
    return {
      creditUsage: [],
      creditAgreements: []
    };
  },
  components: {
    PageContent,
    NetworkAddCreditModal,
    CustomTable
  },
  mounted() {
    this.getCurrentCreditUsage();
    this.getCurrentCreditAgreements();

    this.$nextTick(
      function() {
        this.$eventBus.$on(
          "admin-network-add-credit-refresh-data",
          this.getCurrentCreditAgreements
        );
      }.bind(this)
    );
  },
  methods: {
    async getCurrentCreditUsage() {
      let res = await this.$http.get(
        Config.apiPath + "/api/v2/admin/credits/usage"
      );
      this.creditUsage = res.data;
    },
    async getCurrentCreditAgreements() {
      let res = await this.$http.get(
        Config.apiPath + "/api/v2/admin/credits/agreements"
      );
      this.creditAgreements = res.data;
    },
    networkCreditToggleModal() {
      this.$eventBus.$emit("admin-network-add-credit-open-modal");
    }
  },
  destroyed() {
    this.$eventBus.$off(
      "admin-network-add-credit-refresh-data",
      this.getCurrentCreditAgreements
    );
  }
};
</script>
